import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {SearchTripResponse} from '../model/search-trip-response';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})

export class TripGridService implements GridGetService<SearchTripResponse> {
  private readonly baseUrl = 'dbov2/trip/pagination';
  private readonly http = inject(HttpClient);

  public getExportFilters(filters: any): Record<string, any> {
    const exportFilters: Record<string, any> = { ...filters };
    if (filters['tripStartDateFrom']) {
      exportFilters['tripStartDateFrom'] = moment(filters['tripStartDateFrom']).format('YYYY-MM-DD');
    }
    if (filters['tripStartDateTo']) {
      exportFilters['tripStartDateTo'] = moment(filters['tripStartDateTo']).format('YYYY-MM-DD');
    }
    if (filters['tripEndDateFrom']) {
      exportFilters['tripEndDateFrom'] = moment(filters['tripEndDateFrom']).format('YYYY-MM-DD');
    }
    if (filters['tripEndDateTo']) {
      exportFilters['tripEndDateTo'] = moment(filters['tripEndDateTo']).format('YYYY-MM-DD');
    }
    return exportFilters;
  }

  getItems({filters, page, sort} : GridServiceParams): Observable<GridServiceResponse<SearchTripResponse>>  {
    const params:Record<string, string | number | boolean> = {
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',
      tripName: this.getFilterValue(filters?.['tripName']),
      externalNumber: this.getFilterValue(filters?.['externalNumber']),
      externalReference: this.getFilterValue(filters?.['externalReference']),
      externalStatusTypeId: filters?.['externalStatusTypeId'] ?? '',
      tripStartDateFrom: filters?.['tripStartDateFrom'] ? moment(filters['tripStartDateFrom']).format('YYYY-MM-DD') : '',
      tripStartDateTo: filters?.['tripStartDateTo'] ? moment(filters['tripStartDateTo']).format('YYYY-MM-DD') : '',
      tripEndDateFrom: filters?.['tripEndDateFrom'] ? moment(filters['tripEndDateFrom']).format('YYYY-MM-DD') : '',
      tripEndDateTo: filters?.['tripEndDateTo'] ? moment(filters['tripEndDateTo']).format('YYYY-MM-DD') : '',
      isCancelled: filters?.['isCancelled'] ??  '',
      isArchived: filters?.['isArchived'] ?? '',
      fmsInvoiceId: this.getFilterValue(filters?.['fmsInvoiceId']),
      fmsTripId: this.getFilterValue(filters?.['fmsTripId']),
    };

    if (filters?.['withInvoice'] !== null && filters?.['withInvoice'] !== undefined) {
      params['withInvoice'] = filters['withInvoice'];
    }

    if (params['fmsTripId']) {
      const numValue = parseInt(params['fmsTripId'] as string);
      if (!isNaN(numValue)) {
        params['fmsTripId'] = numValue;
      }
    }

    if (params['fmsInvoiceId']) {
      const numValue = parseInt(params['fmsInvoiceId'] as string);
      if (!isNaN(numValue)) {
        params['fmsInvoiceId'] = numValue;
      }
    }

    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<SearchTripResponse>>(`${this.baseUrl}`, { params: {...params} })
      .pipe(catchError((error:HttpErrorResponse)=>{
        throw new Error(error?.message || 'Server error');
    }));
  }

  private getFilterValue(value: any): string {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'number') return value.toString();
    if (value && typeof value === 'object') {
      if ('id' in value && 'value' in value) {
        return value.value;
      }
      if ('value' in value) {
        return value.value;
      }
    }
    return '';
  }
}
